module.exports = __webpack_public_path__ + "img/3.279c0eed.png";